import React, { FC } from 'react';
import { AdminRoutes } from '../RoutesContainer';
import TopBlock from './TopBlock';

export interface AdminContainerPropsType {}
const AdminContainer: FC<AdminContainerPropsType> = (props) => {
    return (
        <>
            <TopBlock />
            {/* <AdminRoutes /> */}
        </>
    );
};

export default AdminContainer;
